import { render } from "./AddEditSalesGroup.vue?vue&type=template&id=4f5924b0&scoped=true"
import script from "./AddEditSalesGroup.vue?vue&type=script&lang=js"
export * from "./AddEditSalesGroup.vue?vue&type=script&lang=js"

import "./AddEditSalesGroup.vue?vue&type=style&index=0&id=4f5924b0&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5924b0"]])

export default __exports__